import React from "react";
import { SchoolConfig } from "../types/school";
import { Shield, Heart } from "lucide-react";

interface FooterProps {
  config: SchoolConfig;
}

const Footer: React.FC<FooterProps> = ({ config }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-800/80 backdrop-blur-md border-t border-slate-700/50 px-6 py-3">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-3">
          {/* Main Content Row */}
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-y-0">
            {/* Copyright */}
            <div className="flex items-center space-x-2 text-sm text-slate-300">
              <span>
                © {currentYear} {config.name}
              </span>
              <Heart className="w-3 h-3 text-red-400 animate-pulse" />
              <span>All rights reserved</span>
            </div>

            {/* Links */}
            <div className="flex items-center space-x-4 text-sm">
              <a
                href="#"
                className="text-slate-400 hover:text-white transition-colors font-medium"
              >
                Privacy Policy
              </a>
              <span className="text-slate-600">•</span>
              <a
                href="#"
                className="text-slate-400 hover:text-white transition-colors font-medium"
              >
                Terms
              </a>
              <span className="text-slate-600">•</span>
              <a
                href="#"
                className="text-slate-400 hover:text-white transition-colors font-medium"
              >
                Support
              </a>
            </div>

            {/* Status & Security */}
            <div className="flex items-center space-x-4 text-xs">
              <div className="flex items-center space-x-2 text-emerald-400">
                <Shield className="w-3 h-3" />
                <span>Secure</span>
              </div>
              <div className="flex items-center space-x-1 text-slate-400">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span>Online</span>
              </div>
            </div>
          </div>

          {/* EduNexi Attribution */}
          <div className="text-xs text-slate-400">
            Powered by{" "}
            <a
              href="https://edunexi.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-blue-400 hover:text-blue-300 transition-colors"
            >
              EduNexi
            </a>{" "}
            Educational Excellence Platform
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
